import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MapView = ({ terrains = [] }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersLayerRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    mapInstanceRef.current = L.map(mapRef.current).setView([45.3, 5.0], 9);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(mapInstanceRef.current);

    markersLayerRef.current = L.layerGroup().addTo(mapInstanceRef.current);

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
      markersLayerRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!mapInstanceRef.current || !markersLayerRef.current) return;

    markersLayerRef.current.clearLayers();

    if (!terrains.length) {
      mapInstanceRef.current.setView([45.3, 5.0], 9);
      return;
    }

    const greenIcon = L.divIcon({
      className: 'custom-marker',
      html: `<div style="background-color: #c4d600; width: 32px; height: 32px; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3);"><div style="transform: rotate(45deg); color: white; font-size: 18px; text-align: center; line-height: 26px;">📍</div></div>`,
      iconSize: [32, 32],
      iconAnchor: [16, 32]
    });

    terrains.forEach((terrain) => {
      const marker = L.marker([terrain.coordinates.lat, terrain.coordinates.lng], { icon: greenIcon });
      
      // Формируем содержимое popup в зависимости от наличия данных
      let popupContent = `
        <div class="p-2">
          <h3 class="font-semibold text-sm mb-1">${terrain.title}</h3>
      `;
      
      if (terrain.price !== undefined && terrain.price !== null && terrain.price > 0) {
        popupContent += `<p class="text-[#c4d600] font-bold text-sm">${terrain.price.toLocaleString('fr-FR')} €</p>`;
      }
      
      if (terrain.location) {
        popupContent += `<p class="text-xs text-gray-600">${terrain.location}</p>`;
      }
      
      if (terrain.surface !== undefined && terrain.surface !== null && terrain.surface > 0) {
        popupContent += `<p class="text-xs text-gray-600">${terrain.surface} m²</p>`;
      }
      
      if (terrain.status) {
        popupContent += `<p class="text-xs text-[#c4d600] font-semibold mt-1">${terrain.status}</p>`;
      }
      
      popupContent += `</div>`;
      
      marker.bindPopup(popupContent);
      marker.addTo(markersLayerRef.current);
    });

    if (terrains.length > 0) {
      if (terrains.length === 1) {
        // Для одного terrain устанавливаем конкретный zoom
        mapInstanceRef.current.setView(
          [terrains[0].coordinates.lat, terrains[0].coordinates.lng],
          14
        );
      } else {
        // Для нескольких terrains используем fitBounds
        const bounds = L.latLngBounds(terrains.map((t) => [t.coordinates.lat, t.coordinates.lng]));
        mapInstanceRef.current.fitBounds(bounds, { padding: [50, 50] });
      }
    }
  }, [terrains]);

  return (
    <div className="w-full h-full bg-gray-100 rounded-lg overflow-hidden">
      <div ref={mapRef} className="w-full h-full" style={{ minHeight: '500px' }}></div>
    </div>
  );
};

export default MapView;